import React, { useState, useCallback } from 'react';
import { motion } from "framer-motion";

// Ajoute ce hook en haut du fichier avec tes imports
const generateCircles = (count) => {
   const colors = ["bg-purple-700", "bg-blue-700", "bg-pink-700", "bg-green-700", "bg-yellow-700"];
   const circles = [];

   for (let i = 0; i < count; i++) {
      const size = Math.floor(Math.random() * 30) + 5; // tailles entre 5px et 35px
      const color = colors[Math.floor(Math.random() * colors.length)];
      const top = Math.random() * 100; // position verticale %
      const left = Math.random() * 100; // position horizontale %
      const duration = Math.random() * 10 + 10; // entre 10 et 20s

      circles.push({ size, color, top, left, duration });
   }
   return circles;
};


const Masthead = ({
   backgroundImages = {
      blob1: "/home-7/hero/1.svg",
      blob2: "/home-7/hero/2.svg",
      bg: "/home-7/hero/bg.png"
   },
}) => {
   const [isModalOpen, setIsModalOpen] = useState(false);

   const openModal = useCallback(() => setIsModalOpen(true), []);
   const closeModal = useCallback(() => setIsModalOpen(false), []);

   return (
      <div className="relative z-0 py-12 md:py-16 lg:py-24 px-6 md:px-20 lg:px-52">
         {/* Arrière-plan */}
         <div className="h-full object-cover rounded-2xl overflow-hidden">
            <img
               src={backgroundImages.blob1}
               alt="blob"
               className="absolute inset-0 w-full h-full object-cover"
            />
            <img
               src={backgroundImages.blob2}
               alt="blob"
               className="absolute inset-0 w-full h-full object-cover"
            />
            <img
               src={backgroundImages.bg}
               alt="background"
               className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Particules flottantes */}
            <div className="absolute inset-0 overflow-hidden">
               {generateCircles(15).map((circle, idx) => (
                  <motion.div
                     key={idx}
                     className={`absolute rounded-full opacity-30 ${circle.color}`}
                     style={{
                        width: circle.size,
                        height: circle.size,
                        top: `${circle.top}%`,
                        left: `${circle.left}%`,
                     }}
                     animate={{
                        y: [0, -50, 0],
                        x: [0, 30, 0],
                     }}
                     transition={{
                        duration: circle.duration,
                        repeat: Infinity,
                        ease: "easeInOut",
                     }}
                  />
               ))}
            </div>


         </div>
         {/* Contenu */}
         <div className="">
            <div className="container mx-auto px-4 relative z-10">
               {/* Inversion de l'ordre sur mobile pour mettre l'image en premier */}
               <div className="flex flex-col-reverse lg:flex-row items-center gap-10 lg:gap-16">
                  {/* Content Section - maintenant en deuxième position sur mobile */}
                  <div className="lg:w-5/12 mt-8 lg:mt-0">
                     <div className="max-w-lg">
                        <h1 className="text-2xl md:text-3xl lg:text-[30px] font-bold italic text-dark-1 leading-tight mb-6">
                           Little Maker – <br />
                           <span className="text-purple-1">
                              Libère ta créativité en fabriquant le monde de demain
                           </span>
                        </h1>
                        <p className="text-sm text-gray-700 dark:text-gray-300 mb-5">
                           Un parcours pour collégiens et lycéens, mêlant apprentissage guidé, projets pratiques et immersion en FabLab.
                        </p>

                        {/* Buttons */}
                        <div className="flex">
                           <a
                              href="https://app.gonextmaker.com/auth/login"
                              className="px-6 py-2 md:px-8 md:py-3 bg-gradient-to-r from-purple-1 to-red-1
                              text-white font-medium rounded-full hover:text-dark-1 text-sm md:text-base"
                           >
                              Commencez maintenant
                           </a>
                        </div>
                     </div>
                  </div>

                  {/* Image Section - maintenant en première position sur mobile */}
                  <div className="lg:w-7/12 flex justify-center relative">
                     <div className="relative w-[250px] h-[250px] md:w-[380px] md:h-[380px] lg:w-[480px] lg:h-[480px]
   justify-center items-center flex">
                        <img
                           src="/IROKO_IMAGE/young_boy_mbot.png"
                           className="w-full h-full object-contain mx-auto"
                           alt="Little Maker"
                        />

                        {/* Play Button */}
                        <div className="absolute inset-0 flex items-center justify-center">
                           <button
                              onClick={openModal}
                              className="flex items-center justify-center bg-white dark:bg-gray-800 w-12 h-12 md:w-16
                              md:h-16 rounded-full shadow-lg hover:scale-110 transition-transform duration-300 focus:outline-none"
                              aria-label="Watch video"
                           >
                              <svg className="w-5 h-5 md:w-6 md:h-6 text-purple-1" fill="currentColor" viewBox="0 0 24 24">
                                 <path d="M8 5v14l11-7z" />
                              </svg>
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Video Modal */}
            {isModalOpen && (
               <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
                  <div className="relative w-full max-w-4xl mx-4">
                     <button
                        onClick={closeModal}
                        className="absolute -top-10 right-0 text-white text-xl p-2"
                        aria-label="Close video"
                     >
                        ✕
                     </button>
                     <div className="relative aspect-w-16 aspect-h-9">
                        <video
                           className="w-full h-auto rounded-lg"
                           controls
                           autoPlay
                           src="https://docs.material-tailwind.com/demo.mp4"
                        />
                     </div>
                  </div>
               </div>
            )}
         </div>
      </div>
   );
};

export default Masthead;